import addInfoBarMessage from './addInfoBarMessage';
import removeInfoBarMessage from './removeInfoBarMessage';
import setIRMData from './setIRMData';
import { ComposeViewState } from 'owa-mail-compose-store';
import getEncryptionInfoBarMessageId from '../utils/getEncryptionInfoBarMessageId';
import { getComposeHostItemIndex, lazyDeinitializeAddinsForItem } from 'owa-addins-core';
import { isFeatureEnabled } from 'owa-feature-flags';
import RightsManagementFailureCode from 'owa-mail-store/lib/store/schema/RightsManagementFailureCode';
import { ObservableMap } from 'mobx';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';

export default action('protectMessage')(async function protectMessage(
    viewState: ComposeViewState,
    complianceConfigurations: ObservableMap<string, RightsManagementLicenseDataType>,
    templateId: string
) {
    // Set IRM data when
    // 1. IRMData is null, or
    // 2. IRMData is of a different template type
    if (!viewState.IRMData || viewState.IRMData.RmsTemplateId != templateId) {
        if (viewState.IRMData) {
            removeInfoBarMessage(
                viewState,
                getEncryptionInfoBarMessageId(viewState.IRMData.RmsTemplateId)
            );
        }
        const IRMData = createIRMData(viewState, complianceConfigurations.get(templateId));
        if (IRMData) {
            setIRMData(viewState, IRMData);
            addInfoBarMessage(viewState, getEncryptionInfoBarMessageId(IRMData.RmsTemplateId));
            isFeatureEnabled('rp-addins') && // add-ins need to be deinitialized, don't support IRM/SMIME
                lazyDeinitializeAddinsForItem.import().then(deinitializeAddinsForItem => {
                    deinitializeAddinsForItem(getComposeHostItemIndex(viewState.composeId));
                });
        }
    }
});

export function createIRMData(
    viewState: ComposeViewState,
    sourceData: RightsManagementLicenseDataType
): RightsManagementLicenseDataType {
    const userConfig: OwaUserConfiguration = getUserConfiguration();
    let licenseData: RightsManagementLicenseDataType;
    if (sourceData) {
        licenseData = {
            RmsTemplateId: sourceData.RmsTemplateId,
            IsOwner: true,
            RightsManagedMessageDecryptionStatus: RightsManagementFailureCode.Success,
            TemplateName: sourceData.TemplateName,
            TemplateDescription: sourceData.TemplateDescription,
            BodyType: viewState.bodyType,
            ContentOwner: userConfig.SessionSettings.UserEmailAddress,
            EditAllowed: false,
            ReplyAllowed: false,
            ReplyAllAllowed: false,
            ForwardAllowed: false,
            PrintAllowed: false,
            ExtractAllowed: false,
            ProgrammaticAccessAllowed: false,
        };
    }
    return licenseData;
}
